import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/imgs/inserts/mirabella-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-28aa42ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hedge Fund Platforms & Prime Brokers", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("See the whole picture,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("across all your clients.")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "third" }, "One single, powerful platform.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "static" }, "The Derivitec Risk Portal allows you to share reports within your organisation, but also outside your organisation. You can bring all your hedge fund clients onto a single platform, with a consistent set of models and data, allowing them to understand their risks clearly, and you to see the complete picture across the whole portfolio. From regulatory reporting to value-at-risk, bring everyone onto a single, powerful, platform, and keep ahead of the never-ending demands on transparency and risk management.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "third" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "right" }, "Features & Benefits")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Shareability"),
    /*#__PURE__*/_createElementVNode("p", null, "You run a community of funds. Isn’t it time they all had access to best-in-class technology? The Risk Portal allows you to on-board new clients seamlessly, and ensure that their risk, and your risk, is computed in exactly the same way. No more disputes. No more vaguery. Clear, well managed risk, exactly the way you want it.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns flexibility" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Flexibility"),
    /*#__PURE__*/_createElementVNode("p", null, "No two brokerages compute margin the same way. No two brokerages look at risk the same way. Derivitec will work with you to implement the margin rules of you and your liquidity providers, exactly, in our system, and will update accordingly as things change. Our Python technology will allow you to construct whatever report you like, and display it exactly as you and your clients need to see it, and when you’re done, we’ll schedule things to ensure that the reports are run without you having to do anything at all.")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Detail"),
    /*#__PURE__*/_createElementVNode("p", null, "You don’t just need to know where your risks are, you need to know why, and what you can do to manage them. Derivitec takes all the information you’re prepared to give us, down to who traded what, for who, when, so you can drill down to the last detail when things look problematic, before they become a problem.")
  ])
], -1))
const _hoisted_8 = { class: "third" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = { class: "two-thirds" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, [
  /*#__PURE__*/_createElementVNode("p", null, "It is vital that our process uses tools of the highest standard."),
  /*#__PURE__*/_createElementVNode("p", null, "Since we are the market leading regulatory platform it is vital that our process uses tools of the highest standard to be able to calculate and report accurate data held by our managers as required by law. Derivitec has helped a lot in that aspect by providing a clear and easy-to-use platform that we can use to generate our daily SSR report."),
  /*#__PURE__*/_createElementVNode("footer", null, [
    /*#__PURE__*/_createElementVNode("cite", null, "Joe Vittoria"),
    /*#__PURE__*/_createElementVNode("p", null, "CEO | Mirabella")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_client_box = _resolveComponent("client-box")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head bg-right-sm",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns no-gutter-md lopsided-right" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "features" }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_client_box, {
            standalone: true,
            "no-border": true
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            class: "button",
            to: "/clients"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Read More")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}